import {Component, ElementRef, HostListener, OnInit, AfterViewInit} from '@angular/core';
import {GlobalState} from '../../../global.state';
import {layoutSizes} from '../../../theme';

import 'style-loader!./baSidebar.scss';

@Component({
  selector: 'app-ba-sidebar',
  templateUrl: './baSidebar.html'
})
export class BaSidebar implements OnInit, AfterViewInit {
  public menuHeight: number;
  public isMenuCollapsed: boolean;
  public isMenuShouldCollapsed: boolean;

  constructor(private _elementRef: ElementRef, private _state: GlobalState) {

    this.isMenuCollapsed = true;
    this.isMenuShouldCollapsed = true;

    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
  }

  public ngOnInit() {
    if (this._shouldMenuCollapse()) {
      this.menuCollapse();
    }
  }

  public ngAfterViewInit() {
    setTimeout(() => this.updateSidebarHeight());
  }

  @HostListener('window:resize')
  public onWindowResize() {

    const isMenuShouldCollapsed = this._shouldMenuCollapse();

    if (this.isMenuShouldCollapsed !== isMenuShouldCollapsed) {
      this.menuCollapseStateChange(isMenuShouldCollapsed);
    }
    this.isMenuShouldCollapsed = isMenuShouldCollapsed;
    this.updateSidebarHeight();
  }

  public menuExpand() {
    this.menuCollapseStateChange(false);
  }

  public menuCollapse() {
    this.menuCollapseStateChange(true);
  }

  public menuCollapseStateChange(isCollapsed: boolean) {
    this.isMenuCollapsed = isCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
  }

  public updateSidebarHeight() {
    // TODO: get rid of magic 84 constant
    this.menuHeight = this._elementRef.nativeElement.childNodes[0].clientHeight - 84;
  }

  private _shouldMenuCollapse() {
    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
  }

  public toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
    return false;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baSidebar/baSidebar.component.ts